import instance from "@/services/interceptor.js";

export const inviaTicketSupporto = (formData) => {
    return instance.post("/comunicazioni/assistenza", formData, {
        headers: { "Content-Type": "multipart/form-data" }
    });
};

export const getTicketsAssistenzaAdmin = () => {
    return instance.get("/comunicazioni/assistenza/admin/tickets");
};

export const risolviTicketAssistenzaAdmin = (id, data) => {
    return instance.put(`/comunicazioni/assistenza/admin/tickets/${id}/risolvi`, data);
};

export const scaricaAllegatoTicketAdmin = (filename) => {
    return instance.get(`/comunicazioni/assistenza/admin/download/${filename}`, {
        responseType: "blob"
    });
};